module.exports = "<section class=\"page-not-found-section\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\n        <div class=\"section-title\">Site inaccessible sans authentification.</div>\n        <div *ngIf=\"isQuickwin && originUrl != null\" class=\"subsection-title\">Merci de passer par le site principal : <a href=\"{{originUrl}}\">{{originUrl}}</a></div>\n      </div>\n    </div>\n  </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-forbidden/page-forbidden.component.html
// module id = ./src/app/page-forbidden/page-forbidden.component.html
// module chunks = main